import React, { useEffect, useState } from "react";
import MetaTags from "react-meta-tags";
import { Container, Card, CardBody, Row, Col, Label, Button } from "reactstrap";
import { AvField, AvForm } from "availity-reactstrap-validation";
import DeveloperService from "services/Admin/DeveloperService";
import FileUpload from "components/Common/UploadImgCroped/file-upload.component";
// import FileUpload from "components/Common/file-upload/file-upload.component";
import { adminPrefix } from "configs/routePrefix";
import { SuccessCreated, SuccessOk } from "configs/statusCode";
import SuccessModal from "components/SucessModal";
import CancelModal from "components/CancelModal";
import { toast } from "react-toastify";
import Select from "react-select";
import CountriesService from "services/Admin/CountriesService";
import HomeService from "services/Website/HomeService";

const languages = ["en", "ar", "zh", "ru"];
const initialState = {
	en: "",
	ar: "",
	ru: "",
	zh: "",
	Descrip_en: "",
	Descrip_ar: "",
	Descrip_ru: "",
	Descrip_zh: "",
	media_id: "",
	media_id_path: "",
	bank_account: [
		{
			account: "",
			swift: "",
			iban: "",
			currency: {
				currency_name: "Egyptian Pound",
				currency_code: "EGP",
				label: "Egyptian Pound",
				value: "EGP",
			},
			name: "",
		},
	],
	swift: "",
	iban: "",
	country: "",
};
const CreateDeveloperPage = (props) => {
	const [loading, setLoading] = useState(false);
	const developerService = new DeveloperService();
	const countriesService = new CountriesService();
	const homeService = new HomeService();
	const [formState, setFormState] = useState(initialState);
	const [modal, setModal] = useState(false);
	const [successModal, setSuccessModal] = useState(false);
	const [uploadState, setUploadState] = useState(false);
	const [countriesOptions, setCountriesOptions] = useState([]);
	const [currenciesOptions, setCurrenciesOptions] = useState([]);

	const handleSelectChange = (selectedOption) => {
		setFormState({ ...formState, role: selectedOption });
	};

	const updatedAttachment = (attachments, type) => {
		const mediaObj = {
			[`${type}`]: attachments[0]?.id,
			[`${type}_path`]: attachments[0]?.path,
		};
		setFormState({ ...formState, ...mediaObj });
	};

	useEffect(() => {
		countriesService?.getDropDown().then((res) => {
			if (res && res.status == SuccessOk) {
				let optData = res?.data?.map((opt) => {
					return {
						...opt,
						label: opt?.name?.en,
						value: opt?.name?.en,
					};
				});
				setCountriesOptions(optData);
			}
		});

		homeService.getCurrencies()?.then((res) => {
			if (res?.status) {
				let info = res?.data?.map((curr) => {
					return {
						...curr,
						label: curr?.currency_name,
						value: curr?.currency_code,
					};
				});
				setCurrenciesOptions(info);
			}
		});
	}, []);

	// FILE UPLOAD
	const deleteAttachment = (_, type) => {
		const mediaObj = {
			[type]: null,
			[`${type}_path`]: null,
		};
		setFormState({ ...formState, ...mediaObj });
	};

	const handleValidSubmit = (e, v) => {
		if (formState.bank_account?.filter((res) => !res?.currency)?.length) {
			toast.error("Select Currency");
			return;
		}
		setLoading(true);
		const data = {
			name: { en: formState.en },
			description: {},
			media_id: formState.media_id,
			// iban: formState.iban,
			// swift: formState.swift,
			bank_account: formState.bank_account?.map((bank) => {
				return {
					...bank,
					currency: bank?.currency?.value,
				};
			}),
			country_ids: formState?.country?.map((res) => {
				return res.id;
			}),
		};

		languages.forEach((language) => {
			if (formState[language].length) {
				data.name[language] = formState[language];
			}
		});

		languages.forEach((language) => {
			if (formState[`Descrip_${language}`].length) {
				data.description[language] = formState[`Descrip_${language}`];
			}
		});

		developerService.create(data).then((res) => {
			if (res && res.status === SuccessCreated) {
				setLoading(false);
				setSuccessModal(true);
			} else {
				setLoading(false);
			}
		});
	};

	const handleFieldChange = (e) => {
		setFormState({ ...formState, [e.target.name]: e.target.value });
	};

	return (
		<React.Fragment>
			<div className="page-content">
				<MetaTags>
					<title>Developer</title>
				</MetaTags>
				<Container fluid>
					<h4>
						{/* <button className="p-0 m-0 border-0 bg-light"
              onClick={() => {
                 props.history.push(`${adminPrefix}/Admin-developer`)
              }}>
              <i className="fa fa-arrow-left text-primary me-2"></i>
            </button> */}
						Add Developer
					</h4>
					<AvForm
						className="form-horizontal"
						onValidSubmit={(e, v) => {
							handleValidSubmit(e, v);
						}}>
						<Card className="w-100 mt-4">
							<CardBody>
								<Row>
									<Col md={12}>
										<FileUpload
											accept=".jpg,.png,.jpeg,.JPG,.PNG,.JPEG"
											label="Profile Picture"
											attachmentType="media_id"
											setUpload={() => {}}
											attachmentData={formState.media}
											updatedAttachment={updatedAttachment}
											deleteAttachment={deleteAttachment}
											setUploadState={setUploadState}
											ratio={{ x: 1, y: 1 }}
										/>
									</Col>
								</Row>
								<Row className="mb-4">
									<Col md={6}>
										<div className="mb-3">
											<AvField
												errorMessage="This field is required"
												name="en"
												label="Developer Name (en)"
												placeholder={"English"}
												className="form-control"
												required
												onChange={(e) => handleFieldChange(e)}
												bsSize="lg"
											/>
										</div>
									</Col>
									<Col md={6}>
										<div className="mb-3">
											<AvField
												name="ar"
												label="Developer Name (ar)"
												className="form-control"
												placeholder={"العربية"}
												onChange={(e) => handleFieldChange(e)}
												bsSize="lg"
											/>
										</div>
									</Col>
									<Col md={6}>
										<div className="mb-3">
											<AvField
												name="ru"
												label="Developer Name (ru)"
												placeholder={"Русский"}
												className="form-control"
												onChange={(e) => handleFieldChange(e)}
												bsSize="lg"
											/>
										</div>
									</Col>
									<Col md={6}>
										<div className="mb-3">
											<AvField
												name="zh"
												placeholder={"中文"}
												label="Developer Name (zh)"
												className="form-control"
												onChange={(e) => handleFieldChange(e)}
												bsSize="lg"
											/>
										</div>
									</Col>
								</Row>
								<Row>
									<Col md={6}>
										<div className="mb-3">
											<AvField
												name="Descrip_en"
												label="Description (en)"
												className="form-control"
												placeholder="English"
												type="textarea"
												onChange={(e) => handleFieldChange(e)}
												bsSize="lg"
											/>
										</div>
									</Col>
									<Col md={6}>
										<div className="mb-3">
											<AvField
												name="Descrip_ar"
												label="Description (ar)"
												className="form-control"
												placeholder="العربية"
												type="textarea"
												onChange={(e) => handleFieldChange(e)}
												bsSize="lg"
											/>
										</div>
									</Col>
									<Col md={6}>
										<div className="mb-3">
											<AvField
												name="Descrip_ru"
												label="Description (ru)"
												placeholder="Русский"
												className="form-control"
												type="textarea"
												onChange={(e) => handleFieldChange(e)}
												bsSize="lg"
											/>
										</div>
									</Col>
									<Col md={6}>
										<div className="mb-3">
											<AvField
												name="Descrip_zh"
												label="Description (zh)"
												placeholder="中文"
												className="form-control"
												type="textarea"
												onChange={(e) => handleFieldChange(e)}
												bsSize="lg"
											/>
										</div>
									</Col>
								</Row>
							</CardBody>
						</Card>

						<Card>
							<CardBody>
								<Row>
									<Col md={6} className="mb-3 ">
										<label>Select Country</label>
										<Select
											placeholder="Select"
											options={countriesOptions}
											onChange={(data) => {
												setFormState({ ...formState, country: data });
											}}
											value={formState.compound}
											isMulti={true}
										/>
									</Col>
								</Row>
							</CardBody>
						</Card>
						{/* <Card>
              <CardBody>
                <Row>
                <Col md={6}>
                      <AvField
                          errorMessage="this field is required"
                          className="mb-3"
                          name={"iban"}
                          label="IBAN No."
                          bsSize="lg"
                          validate={{
                            required: {value: true, errorMessage: 'This Field is required'},
                            pattern: {value: '/^[A-Za-z0-9\b]+$/', errorMessage: "IBAN format is invalid"}
                          }}
                          required
                          onChange={e => handleFieldChange(e)}
                          placeholder="IBAN No."
                          type="text"
                      />
                  </Col>
                  <Col md={6}>
                      <AvField
                          errorMessage="this field is required"
                          className="mb-3"
                          name={"swift"}
                          label="Swift Code"
                          bsSize="lg"
                          validate={{
                            required: {value: true, errorMessage: 'This Field is required'},
                            pattern: {value: '/^[A-Za-z0-9\b]+$/', errorMessage: "Swift format is invalid"}
                          }}
                          required
                          onChange={e => handleFieldChange(e)}
                          placeholder="Swift Code"
                          type="text"
                      />
                  </Col>
                  <Col md={6}>
                      <AvField
                          errorMessage="this field is required"
                          className="mb-3"
                          name={"bank_account"}
                          label="Account Number"
                          validate={{
                            required: {value: true, errorMessage: 'This Field is required'},
                            pattern: {value: '/^[0-9\b]+$/', errorMessage: "Bank Account format is invalid"}
                          }}
                          bsSize="lg"
                          required
                          onChange={e => handleFieldChange(e)}
                          placeholder="Account Number"
                          type="text"
                      />
                  </Col>
                </Row>
              </CardBody>
            </Card> */}

						<Card>
							<CardBody>
								{formState?.bank_account?.map((res, index) => {
									return (
										<Row
											key={index}
											className="mb-3"
											style={{
												border:
													formState?.bank_account?.length > 1
														? "1px solid #dedede"
														: "",
												padding:
													formState?.bank_account?.length > 1
														? ".5rem 0 1rem"
														: "",
												borderRadius:
													formState?.bank_account?.length > 1 ? "10px" : "",
											}}>
											{index > 0 && (
												<Col md={12} style={{ textAlign: "right" }}>
													<button
														className="btn btn-light"
														type="button"
														onClick={() => {
															const update = formState.bank_account.filter(
																(_, ind) => ind !== index
															);
															setFormState({
																...formState,
																bank_account: update,
															});
														}}
														style={{
															color: "red",
															fontWeight: "600",
														}}>
														X
													</button>
												</Col>
											)}
											<Col md={6}>
												<AvField
													className="mb-3"
													name={`name${index}`}
													label="Account Name"
													validate={{
														required: {
															value: true,
															errorMessage: "This Field is required",
														},
													}}
													bsSize="lg"
													value={res?.name}
													onChange={(e) => {
														let update = formState?.bank_account?.map(
															(info, ind) => {
																if (ind === index) {
																	return {
																		...info,
																		name: e?.target?.value,
																	};
																} else {
																	return info;
																}
															}
														);
														setFormState({
															...formState,
															bank_account: update,
														});
													}}
													placeholder="Account Name"
													type="text"
												/>
											</Col>
											<Col md={6}>
												<AvField
													errorMessage="this field is required"
													className="mb-3"
													name={`iban${index}`}
													label="IBAN No."
													bsSize="lg"
													validate={{
														required: {
															value: true,
															errorMessage: "This Field is required",
														},
														pattern: {
															value: "/^[A-Za-z0-9\b]+$/",
															errorMessage: "IBAN format is invalid",
														},
													}}
													value={res?.iban}
													onChange={(e) => {
														let update = formState?.bank_account?.map(
															(info, ind) => {
																if (ind === index) {
																	return {
																		...info,
																		iban: e?.target?.value,
																	};
																} else {
																	return info;
																}
															}
														);
														setFormState({
															...formState,
															bank_account: update,
														});
													}}
													placeholder="IBAN No."
													type="text"
												/>
											</Col>
											<Col md={6}>
												<AvField
													errorMessage="this field is required"
													className="mb-3"
													name={`swift${index}`}
													label="Swift Code"
													bsSize="lg"
													validate={{
														required: {
															value: true,
															errorMessage: "This Field is required",
														},
													}}
													value={res?.swift}
													onChange={(e) => {
														let update = formState?.bank_account?.map(
															(info, ind) => {
																if (ind === index) {
																	return {
																		...info,
																		swift: e?.target?.value,
																	};
																} else {
																	return info;
																}
															}
														);
														setFormState({
															...formState,
															bank_account: update,
														});
													}}
													placeholder="Swift Code"
													type="text"
												/>
											</Col>
											<Col md={6}>
												<AvField
													className="mb-3"
													name={`bank_account${index}`}
													label="Account Number"
													validate={{
														required: {
															value: true,
															errorMessage: "This Field is required",
														},
													}}
													bsSize="lg"
													value={res?.account}
													onChange={(e) => {
														let update = formState?.bank_account?.map(
															(info, ind) => {
																if (ind === index) {
																	return {
																		...info,
																		account: e?.target?.value,
																	};
																} else {
																	return info;
																}
															}
														);
														setFormState({
															...formState,
															bank_account: update,
														});
													}}
													placeholder="Account Number"
													type="text"
												/>
											</Col>
											<Col md={6}>
												<label>Select Currency</label>
												<Select
													placeholder="Select"
													options={currenciesOptions}
													// options={index > 0 ? currenciesOptions : [{label: 'EGP', value: 'EGP'}]}
													value={res?.currency}
													// isDisabled={index===0}
													onChange={(e) => {
														let update = formState?.bank_account?.map(
															(info, ind) => {
																if (ind === index) {
																	return {
																		...info,
																		currency: e,
																	};
																} else {
																	return info;
																}
															}
														);
														setFormState({
															...formState,
															bank_account: update,
														});
													}}
												/>
											</Col>
										</Row>
									);
								})}
								<Button
									className="mt-4"
									onClick={() => {
										setFormState({
											...formState,
											bank_account: [
												...formState.bank_account,
												{
													account: "",
													swift: "",
													iban: "",
													name: "",
													currency: "",
												},
											],
										});
									}}
									variant="light">
									Add New Bank Account
								</Button>
							</CardBody>
						</Card>

						<Row className="d-flex justify-content-between pb-4">
							<Col>
								<button
									type="button"
									className="btn btnUpload btnHeight px-4"
									onClick={() => {
										setModal(true);
									}}
									size={"lg"}>
									Cancel
								</button>
							</Col>
							<Col>
								<button
									type="submit"
									className="btn btn-success btnHeight px-4 float-end"
									size={"lg"}
									disabled={uploadState ? true : loading ? true : false}>
									Submit
								</button>
							</Col>
						</Row>
						<CancelModal
							modal={modal}
							setModal={setModal}
							goBackHandler={() =>
								props.history.push(`${adminPrefix}/Admin-developer`)
							}
						/>
					</AvForm>
					<SuccessModal
						modal={successModal}
						message="Added developer successfully"
						onClick={() => {
							props.history.push(`${adminPrefix}/Admin-developer`);
						}}
						title="Add Developer"
					/>
				</Container>
			</div>
		</React.Fragment>
	);
};

export default CreateDeveloperPage;
